// extracted by mini-css-extract-plugin
export default {"wrapper":"zkvVQeRK","Tooltip":"HKvlXXQL"};